import _default from './Form';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/collections/Form/index.js
// module id = 943
// module chunks = 0